import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AdminBarAction {
    label: string;
    href: string;
    /** Actions open in a new tab by default, since most of them lead to the panel. */
    sameTab?: boolean;
}

interface AdminBarState {
    actions: AdminBarAction[];
}

const initialState: AdminBarState = {
    actions: [],
};

const adminBarSlice = createSlice({
    name: "adminBar",
    initialState,
    reducers: {
        setAdminBarActions(state, action: PayloadAction<AdminBarAction[]>) {
            state.actions = action.payload;
        },
    },
});

export const { setAdminBarActions } = adminBarSlice.actions;
export default adminBarSlice;
